import {FETCH_SPACECOUNTRYDATA_FAILS} from "../Spaces/SpaceActionTypes";
import {
    ADD_REVIEW,
    ADD_REVIEW_FAILS,
    ADD_REVIEW_SUCCESS,
    DELETE_REVIEW,
    DELETE_REVIEW_FAILS,
    DELETE_REVIEW_SUCCESS,
    FETCH_REVIEW_DATA,
    FETCH_REVIEW_DATA_FAILS,
    FETCH_REVIEW_DATA_SUCCESS,
    FETCH_SPACE_DATA,
    FETCH_SPACE_DATA_FAILS,
    FETCH_SPACE_DATA_SUCCESS,
    FETCH_USER_DATA,
    FETCH_USER_DATA_FAILS,
    FETCH_USER_DATA_SUCCESS,
    UPDATE_REVIEW, UPDATE_REVIEW_FAILS,
    UPDATE_REVIEW_SUCCESS,
    CLEAR_REVIEW_DETAILS,
} from "./SpaceReviewActionTypes";

export const spaceReviewReducer = (
    state = {},
    action
) => {
    switch (action.type) {
        case FETCH_SPACE_DATA:
            return {
                ...state,
                fetching: true
            };
        case FETCH_SPACE_DATA_SUCCESS:
            return {
                ...state,
                fetching: false,
                spaceData: {
                    ...state.spaceData,
                    fetching: false,
                    data: { status: true, message: action.payload }
                }
            };
        case FETCH_SPACE_DATA_FAILS:
            return {
                ...state,
                fetching: false,
                spaceData: {
                    ...state.spaceData,
                    fetching: false,
                    error: { status: true, message: action.payload }
                }
            };
        case FETCH_REVIEW_DATA:
            return {
                ...state,
                fetching: true
            };
        case FETCH_REVIEW_DATA_SUCCESS:
            return {
                ...state,
                fetching: false,
                reviews: action.payload
            };
        case FETCH_REVIEW_DATA_FAILS:
            return {
                ...state,
                fetching: false,
                reviews: [],
                errorMessage: action.payload
            };
        case FETCH_USER_DATA:
            return {
                ...state,
                fetching: true
            };
        case FETCH_USER_DATA_SUCCESS:
            return {
                ...state,
                fetching: false,
                users: action.payload
            };
        case FETCH_USER_DATA_FAILS:
            return {
                ...state,
                fetching: false,
                users: [],
                errorMessage: action.payload
            };

        case ADD_REVIEW:
            return {
                ...state,
                fetching: true
            };
        case ADD_REVIEW_SUCCESS:
            return {
                ...state,
                fetching: false,
                addReview: action.payload,
                errorMessage: {}
            };
        case ADD_REVIEW_FAILS:
            return {
                ...state,
                fetching: false,
                addReview: [],
                errorMessage: action.payload
            };

        case UPDATE_REVIEW:
            return {
                ...state,
                fetching: true
            };
        case UPDATE_REVIEW_SUCCESS:
            return {
                ...state,
                fetching: false,
                updateReview: action.payload,
                errorMessage: {}
            };
        case UPDATE_REVIEW_FAILS:
            return {
                ...state,
                fetching: false,
                updateReview: [],
                errorMessage: action.payload
            };

        case DELETE_REVIEW:
            return {
                ...state,
                fetching: true
            };
        case DELETE_REVIEW_SUCCESS:
            return {
                ...state,
                fetching: false,
                deleteReview: action.payload,
                errorMessage: {}
            };
        case DELETE_REVIEW_FAILS:
            return {
                ...state,
                fetching: false,
                deleteReview: [],
                errorMessage: action.payload
            };
        case CLEAR_REVIEW_DETAILS:
            return {
                ...state,
                fetching: false,
                reviews:[],
                errorMessage: {}
            };

        default:
            return state;
    }
};
